import { API_URL } from '../constants';
import fetchAuthorization from './fetchAuthorization';
import qs from 'qs';

export interface Player {
  row_num: number;
  player_id: string;
  team_id: string;
  first_name: string;
  last_name: string;
  jersey_number: number;
  active_YN: number;
  createdAt: string;
  is_active_YN: number;
  created_by: string;
  created_datetime: string;
}

export type PlayerGamesStats = {
  player_id?: string | undefined;
  team_year?: number | undefined;
  sport_id?: number | undefined;
  limit?: number | undefined;
  offset?: number | undefined;
};

export async function fetchPlayerGameStats(opts: PlayerGamesStats): Promise<Player[]> {
  try {
    const query = qs.stringify({
      player_id: opts.player_id,
      team_year: opts.team_year,
      sport_id: opts.sport_id || 1,
    });

    const response = await fetchAuthorization(`${API_URL}player_game_stats?${query}`);

    const result = await response.json();

    return result;
  } catch (e: any) {
    throw new Error(`Something went wrong. Error message: ${e.message}`);
  }
}

export default fetchPlayerGameStats;
